<template>
    <div>
        <div class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h1 class="m-0 text-capitalize">{{ this.$route.name }}</h1>
                    </div>
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item">
                                <router-link to="/">Home</router-link>
                            </li>
                            <li class="breadcrumb-item active text-capitalize"><i class="fas fa-gift"></i> {{ this.$route.name }}</li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <section class="content">
            <div class="container-fluid">
                <data-table-wrapper
                    ref="giveawaysTable"
                    :columns="columns"
                    :filters="filters"
                    endpoint="/giveaways"
                    sort-column-default="id"
                    sort-order-default="DESC"
                    :disable-edit-action="true"
                    :disable-delete-action="true"
                ></data-table-wrapper>
            </div>
        </section>
    </div>
</template>

<script>
import DataTableWrapper from '../components/DataTableWrapper';

export default {
    components: {
        DataTableWrapper,
    },
    data() {
        return {
            columns: [
                {
                    field: 'operatorName',
                    title: 'Operator',
                },
                {
                    field: 'uid',
                    title: 'UID',
                    sorting: true,
                },
                {
                    field: 'featureType',
                    title: 'Feature type',
                    sorting: true,
                },
                {
                    field: 'gameName',
                    title: 'Target game',
                },
                {
                    field: 'status',
                    title: 'Status',
                    sorting: true,
                },
                {
                    field: 'winAmount',
                    title: 'Win amount',
                },
                {
                    field: 'triggeredGameName',
                    title: 'Triggered game',
                },
                {
                    field: 'createdAt',
                    title: 'Created at',
                    isDate: true,
                    sorting: true,
                },
                {
                    field: 'triggeredAt',
                    title: 'Triggered at',
                    isDate: true,
                    sorting: true,
                },
            ],
            filters: [
                {
                    field: 'operatorId',
                    placeholder: 'Enter operator id',
                    label: 'Operator id',
                },
                {
                    field: 'uid',
                    placeholder: 'Enter UID',
                    label: 'UID',
                },
                {
                    field: 'featureType',
                    placeholder: 'wheelOfFortune | jackpot | bonusGame',
                    label: 'Feature type',
                },
                {
                    field: 'status',
                    placeholder: 'pending | done',
                    label: 'Status',
                },
            ],
        };
    },
};
</script>
